import {
  QuerySupplierOfficesOrderByColumn,
  SortOrder,
  SupplierOfficeListQueryVariables,
} from "@/gql/graphql";
import type { OfficeListSearchParams } from "@/app/Offices/Routes/officeRoutes";

export function getOfficeListQueryVariables(
  searchParams: OfficeListSearchParams,
  supplierId: string | null,
): SupplierOfficeListQueryVariables {
  const baseParams: SupplierOfficeListQueryVariables = {
    first: 20,
    page: 1,
    search: searchParams.officeSearch || undefined,
    supplier_id: supplierId ?? undefined,
    archived: false,
  };

  if (searchParams.officeSearch) {
    return baseParams;
  }
  return {
    ...baseParams,
    orderBy: [
      {
        order: SortOrder.Asc,
        column: QuerySupplierOfficesOrderByColumn.Name,
      },
    ],
  };
}
